import auth from '../features/authentication/redux/slice';
import variant_workflow from '../features/variant_workflow/redux/slice';
import language from './language/slice';

// Root Reducer.
export default () => ({
  auth,
  variant_workflow,
  language,
});
